import React from "react";
import * as P from "./style";
import PostHeader from "./PostHeader";
import PostFooter from "./PostFooter";

import { FeedPosts } from "../../Config/interface.config";
import { Capitalize } from "../../Utils";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { isCreatorRole } from "../../Config/common.config";
import PostSlider from "./PostSlider";

interface Props {
  locked?: boolean;
  post: FeedPosts;
  userImage?: string;
  isSubscribed?: boolean;
}

const Post: React.FC<Props> = ({
  post,
  userImage,
  isSubscribed,
}: Props) => {
  const user = useSelector((state: RootState) => state.user);
  const isPostLocked = post?.isLocked && !isCreatorRole(user.role) && !isSubscribed;
  return (
    <P.Post $locked={isPostLocked}>
      <PostHeader post={post} userImage={userImage} />
      <P.Description>{Capitalize(post?.text)}</P.Description>
      <PostSlider post={post} locked={isPostLocked} isSubscribed={isSubscribed} />
      {!isPostLocked && <PostFooter post={post} />}
    </P.Post>
  );
};

export default Post;
